import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useT } from "@/lib/translation";

interface Props {
  onReset?: () => void;
}

const PageErrorFallback = ({ onReset }: Props) => {
  const t = useT();
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4 text-center p-8">
      <AlertTriangle className="h-12 w-12 text-destructive" />
      <h2 className="text-xl font-semibold">
        {t("common:pageErrorFallback.title")}
      </h2>
      <p className="text-muted-foreground max-w-sm">
        {t("common:pageErrorFallback.body")}
      </p>
      <div className="flex gap-3">
        {onReset && (
          <Button variant="outline" onClick={onReset}>
            {t("common:actions.tryAgain")}
          </Button>
        )}
        <Button onClick={() => window.location.reload()}>
          {t("common:actions.reloadPage")}
        </Button>
      </div>
    </div>
  );
};

export default PageErrorFallback;
